import type { ComponentProps } from "react";
import { CryptographyWrapper } from "@builddocs/cryptography-js";

type CryptographyProps = ComponentProps<typeof CryptographyWrapper>;

export type JournalSignSuccessHandler = (
  data: string,
  proxyId: string | null,
  mchdId?: string,
) => void;

export type JournalCryptographyWrapperProps = Omit<
  CryptographyProps,
  "signType" | "proxy" | "proxyIsEnabled" | "onSuccess" | "signMode"
> & {
  signMode?: "single";
  onSuccess?: JournalSignSuccessHandler;
};

export type PoaListItem = {
  poaIdInternal?: string;
  poaNumber?: string;
  poaName?: string;
  id?: string;
  poaId?: string;
  mchdId?: string;
  number?: string;
};

export const injectMchdId = (xml: string, poaNumber?: string) => {
  if (!xml || !poaNumber) return xml;

  const withOpenClose = xml.replace(
    /<((?:[\w]+:)?)mchdId(\b[^>]*)>([^<]*)<\/((?:[\w]+:)?)mchdId>/g,
    `<$1mchdId$2>${poaNumber}</$4mchdId>`,
  );
  if (withOpenClose !== xml) return withOpenClose;

  const closing = xml.match(/<\/signature>/i);
  if (closing?.index !== undefined) {
    return `${xml.slice(0, closing.index)}<mchdId>${poaNumber}</mchdId>${xml.slice(closing.index)}`;
  }

  return xml;
};

export const resolveUserId = (user: unknown) => {
  const raw = user as { userId?: string; user_id?: string } | undefined;
  return raw?.userId || raw?.user_id || "";
};

export const normalizeCurrentUser = (user: unknown) => {
  const raw = user as {
    userId?: string;
    user_id?: string;
    firstName?: string;
    lastName?: string;
    surname?: string;
    middleName?: string;
  };

  return {
    userId: raw?.userId || raw?.user_id || "",
    firstName: raw?.firstName || "",
    lastName: raw?.lastName || raw?.surname || "",
    surname: raw?.surname || raw?.lastName || "",
    middleName: raw?.middleName || "",
  };
};

export const mapPoaList = (list: unknown): PoaListItem[] => {
  if (!Array.isArray(list)) return [];
  return list.map((item: PoaListItem) => ({
    ...item,
    poaIdInternal: item.poaIdInternal || item.id || item.poaId,
    poaNumber: item.poaNumber || item.mchdId || item.number,
  }));
};
